import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { StoreFilter } from '../../models/store.model';
import { NotificationBuilder } from '../../shared/notificationBuilder'
import { AuthenticationService } from '../../authentication/authentication.service';
import { Router, ActivatedRoute } from '@angular/router'
import { StoreStatement, FinanceInfoDTO, StoreStatementManualDto, StoreStatementNgoManualDto } from '../../models/profile.model';
import { NgxSmartModalService } from 'ngx-smart-modal';
import List from "typescript-dotnet-umd/System/Collections/List";
import { Configuration } from 'src/app/app.constants';
import { StatementService } from 'src/app/services/statement.service';

declare var $: any;
declare var swal: any;

@Component({
  selector: 'app-admin-finance',
  templateUrl: './admin-finance.component.html',
  styleUrls: ['./admin-finance.component.css'],
})

export class AdminFinanceComponent implements OnInit {
  loading = false
  constructor(private router: Router, private route: ActivatedRoute, private dashboardService: DashboardService, private statementService: StatementService, public ngxSmartModalService: NgxSmartModalService, private authenticationService: AuthenticationService, private notificationBuilder: NotificationBuilder) {
  }
  //accounts: AccountModel[] = null
  invoice: StoreStatement = null
  invoiceTypeEdit: string = null //se a q estamos editando eh safe2pay ou iugu
  editInvoiceId: string = null
  statements: StoreStatement[] = null
  finance: FinanceInfoDTO = null
  statementEdit: StoreStatement = null
  manualInvoice: StoreStatementManualDto = null
  totalRevenue: number = 0
  totalDonated: number = 0
  mergeIdList: string
  monthMetrics: List<number> = null
  storeFilter: StoreFilter

  ngOnInit() {
    this.storeFilter = new StoreFilter()

    this.route.queryParamMap.subscribe(params => {
      // debugger
      // this.editInvoiceId = '6c5d2919-1063-4290-82ef-cecc7ebadb8d';
      // return
      if (params["params"].full) {
        if (params["params"].month && params["params"].year) {
          this.load(params["params"].full, params["params"].month, params["params"].year);
        }
        else {
          this.load(params["params"].full, null, null);
        }

      }
      else {
        this.load(false, null, null)
      }
    });


    //this.load(false)
  }

  loadFull() {
    this.load(true, null, null)
  }

  load(full: boolean, month, year) {

    if (!this.authenticationService.isAdministrator())
      this.router.navigate(['/'])

    this.loading = true
    let obj = this
    this.dashboardService.getAdminFinanceInfo(full, month, year).subscribe(data => {
      debugger
      this.finance = data;
      console.log(data)
      obj.loading = false
      var today = new Date(new Date())

      // if (this.finance.statements != null) {

      //   this.finance.statements.forEach(function (invoice) {
      //     debugger
      //     if (invoice.planSeoName == null) {

      //     }

      //     invoice.filterShow = true
      //     if (invoice.polenSubscription == 0 && invoice.totalCommission == 0) {
      //       obj.totalRevenue += (invoice.totalDonationApproved * invoice.commissionPercentage)
      //       if (invoice.commissionPercentage <= 0) {
      //         obj.totalDonated += invoice.totalDonationApproved
      //       }
      //       else {
      //         obj.totalDonated += (invoice.totalDonationApproved * (1 - invoice.commissionPercentage))
      //       }

      //     }
      //     else {
      //       obj.totalRevenue += invoice.polenSubscription + invoice.totalCommission
      //       obj.totalDonated += invoice.totalDonationApproved - invoice.totalCommission
      //     }
      //   });
      // }

      setTimeout(() => {
        obj.filterStatement('all')
      }, 1000);
      //console.log(this.finance.monthFinance)
    })
  }

  updateMonth(date: any, $event: any) {
    debugger
    this.loading = true
    $($event.target).parent().remove()
    var d = new Date(date);
    var obj = this
    this.dashboardService.getAdminMonthlyFinanceControl(d.getMonth() + 1, d.getFullYear()).subscribe(data => {
      debugger
      try {
        if (data.success) {
          var month = data.data;
          if (month.statements != null) {
            month.statements.forEach(function (invoice) {
              invoice.filterShow = true
            });
          }

          if (obj.finance.monthFinance != null) {
            var i = 0;
            var monthIndex = 0;
            obj.finance.monthFinance.forEach(function (m) {
              var dateActual = new Date(m.month);
              if (d.getMonth() == dateActual.getMonth() && d.getFullYear() == dateActual.getFullYear()) {
                monthIndex = i;
              }
              i++;
            });

            obj.finance.monthFinance[monthIndex] = month;
          }
        }
        else {
          this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro ')
          console.log('nao carregou por alguma razao')
        }
      }
      catch (e) {
        this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro ')
        console.log(e)
      }
      obj.loading = false
    })
  }

  getAnswer(step: string, form: any) {
    if (step == 'invoiceEdit') {
      this.editInvoiceId = null
      console.log(form.invoice);
    }
  }

  editInvoice(invoice: StoreStatement) {
    this.loading = true;
    this.editInvoiceId = invoice.id

    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }

  //gerar nota fiscal
  createTaxStatement(invoice: StoreStatement, $event: any) {
    debugger
    if (invoice.invoiceId == null) {
      this.notificationBuilder.showNotification('danger', 1000, 'Não foi encontrado o Id da Iugu')
    }
    else {
      swal({
        type: 'warning',
        title: 'Quer gerar a Nota Fiscal?',
        text: 'Cuidado para evitar duplicação de NF.',
        confirmButtonText: 'Quero Gerar',
        cancelButtonText: 'Deixa quieto',
        reverseButtons: true
      }).then((result) => {
        if (result) {
          this.dashboardService.createNfeIoInvoiceByStatementId(invoice.storeSeoName, invoice.id).subscribe(data => {
            if (data.success) {
              this.notificationBuilder.showNotification('success', 1000, 'NF criada com sucesso!')
            } else {
              console.log(data.error)
              this.notificationBuilder.showNotification('danger', 1000, data.error)
            }
            $($event.target).remove()
            //window.location.reload()
          })
        }
      })

    }
  }

  coloredInvoiceLine(statement: StoreStatement) {

    //se invoice estiver com trial, eh erro grave
    if (statement.planSeoName == 'trial')
      return '#d40000';

    //se nao estiver pago ou estiver com problema, deixamos vermelhinho
    if (statement.statusStatement == 20 || statement.statusStatement == 11)
      return '#f002';

    //se a invoice é para free não gera invoice e não fica marcado
    if(statement.invoiceId != null && statement.invoiceId.includes("p2p_"))
      return 'inherit';

    //se o invoice não estiver gerado, geramos aqui.
    if (statement.invoiceUrl == null || statement.invoiceUrl == '')
      return '#f9e5ac';

    return 'inherit';
  }

  deleteStatement(invoice, event: any, $event: any) {
    swal({
      type: 'warning',
      title: 'Tem certeza?',
      text: 'Vai deletar PRA SEMPRE! Pense bem.',
    }).then((result) => {
      if (result) {
        this.dashboardService.deleteStatement(invoice.id).subscribe(data => {
          if (data) {
            this.notificationBuilder.showNotification('success', 1000, 'DELETADO!')
            $($event.target).parents("tr").remove()
          } else {
            this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a busca pela fatura')
          }
          //window.location.reload()
        })
      }
    })

  }

  createStatementAsk(invoice: StoreStatement, date) {
    var obj = this
    swal({
      title: 'Tem Certeza?',
      text: "Confira antes de gerar a invoice!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Com Iugu',
      cancelButtonText: 'Sem Iugu',
      reverseButtons: true
    }).then((result) => {
      obj.createStatement(invoice, date, true)
    }, function (dismiss) {
      if (dismiss === 'cancel') {
        obj.createStatement(invoice, date, false)
      }
    })
  }

  createStatement(invoice: StoreStatement, date, iugu) {
    debugger
    var newDate = new Date(date);
    this.statementService.adminCreateStatement(invoice.storeSeoName, newDate.getMonth() + 1, newDate.getFullYear(), invoice.polenSubscription, false, iugu).subscribe(data => {
      if (data) {
        this.notificationBuilder.showNotification('success', 1000, 'Fatura criada com sucesso!')
      } else {
        this.notificationBuilder.showNotification('danger', 1000, 'ocorreu algum erro durante a busca pela fatura')
      }
      window.location.reload()
    })
  }

  chooseCreateInvoiceFromStatement(invoice: any) {
    debugger
    var obj = this;

    swal({
      title: "Qual meio de pagamento?",
      text: "digite: juno ou iugu",
      input: 'text',
      showCancelButton: true
    }).then((result) => {
      debugger
      var paymentType = -1
      if (result == 'juno') {
        paymentType = 5
      }
      if (result == 'iugu') {
        paymentType = 0
      }
      if (paymentType >= 0) {
        swal({
          icon: 'info',
          title: "Realizar Pagamento?",
          text: "Se tiver cartão cadastrado, criar fatura e também pagar com cartão?",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          cancelButtonText:
            '<i class="far fa-credit-card"></i> Sim, pagar!',
          confirmButtonText:
            '<i class="fas fa-file-invoice"></i> Apenas Fatura'
        }).then((result2) => {
          debugger
          console.log('só gera a fatura sem pagamento')
          obj.createInvoiceFromStatement(invoice, paymentType, false);
        }, function (dismiss2) {
          debugger
          if (dismiss2 === 'cancel') {
            console.log('faz com pagamento')
            obj.createInvoiceFromStatement(invoice, paymentType, true);
          }
        });
      }
      else {
        obj.notificationBuilder.showNotification('danger', 1000, 'não entendi o que você quer da vida...')
      }

    }, function (dismiss) {
      if (dismiss === 'cancel') {
      }
    });
  }

  createInvoiceFromStatement(invoice: StoreStatement, invoiceType: number, chargeCreditCard: boolean) {
    this.dashboardService.createInvoiceStatement(invoice.id, invoiceType, chargeCreditCard).subscribe(data => {
      if (data != null && data.success) {
        this.notificationBuilder.showNotification('success', 1000, 'Fatura na Iugu criada com sucesso!')
      } else {
        this.notificationBuilder.showNotification('danger', 1000, data.error)
      }
      //window.location.reload()
    })
  }

  filterStatement(type) {
    debugger
    console.log('filtrando');
    this.finance.monthFinance.forEach(function (month) {
      if (month.statements != null) {
        month.statements.forEach(function (invoice) {
          if (type == 'all') {
            invoice.filterShow = true
          } else if (type == 'paid') {
            invoice.filterShow = (invoice.statusStatement >= 2 && invoice.statusStatement < 10)
          }
          else if (type == 'waiting') {
            invoice.filterShow = invoice.statusStatement < 2
          }
          else if (type == 'expired') {
            invoice.filterShow = invoice.statusStatement == 11
          }
          else if (type == 'refund') {
            invoice.filterShow = invoice.statusStatement == 21
          }
          else if (type == 'donated') {
            invoice.filterShow = invoice.hasDonation
          }
          else if (type == 'problem') {
            invoice.filterShow = invoice.statusStatement == 20
          }
          else if (type == 'iugu') {
            invoice.filterShow = invoice.invoiceType == 0
          }
          else if (type == 'juno') {
            invoice.filterShow = invoice.invoiceType == 5
          }
          else if (type == 'hide-carrefour') {
            if (invoice.storeName != null && invoice.storeName != "")
              invoice.filterShow = invoice.storeName.indexOf("Carrefour") < 0;
          }
          else if (type == 'renovation') {
            invoice.filterShow = invoice.polenSubscription > 0
              && invoice.totalDonationApproved == 0
              && (invoice.planSeoName.indexOf('anual') >= 0 || invoice.planSeoName.indexOf('trimestral') >= 0 || invoice.planSeoName.indexOf('semestral') >= 0)
          }
          //Retira todas as lojas free
          invoice.filterShow = invoice.planSeoName != "free";

        });
      }
    });
  }

  filterByName() {
    var keyname = this.storeFilter.byname.toLowerCase()
    this.finance.monthFinance.forEach(function (month) {
      if (month.statements != null) {
        month.statements.forEach(function (invoice) {
          debugger
          invoice.filterShow = (invoice.storeName != null && invoice.storeName.toLowerCase().indexOf(keyname) >= 0) || (invoice.storeSeoName != null && invoice.storeSeoName.toLowerCase().indexOf(keyname) >= 0) || (invoice.planSeoName != null && invoice.planSeoName.toLowerCase().indexOf(keyname) >= 0)
        });
      }
    });
  }

  uploadDonationReceipt() {
    //todo
    this.ngxSmartModalService.getModal('uploadDonationDepositModal').open()
  }

  uploadFileDonation() {
    //todo
  }

  showMergeModal() {
    this.ngxSmartModalService.getModal('mergeModal').open()
  }

  showManualStatement() {
    this.manualInvoice = new StoreStatementManualDto()
    this.manualInvoice.ngos = new Array<StoreStatementNgoManualDto>()
    this.ngxSmartModalService.getModal('manualStatementModal').open()
    $('body').addClass('sidebar-mini');
  }

  manualInvoiceSetNgo(type) {
    debugger
    if (type == "plus") {
      var newNgo = new StoreStatementNgoManualDto()
      newNgo.ngoUrl = ''
      newNgo.donation = 0
      this.manualInvoice.ngos.push(newNgo)
    }
    else {
      this.manualInvoice.ngos.pop()
    }
  }

  createManualStatement() {
    console.log(JSON.stringify(this.manualInvoice))

    this.dashboardService.createManualStatement(this.manualInvoice).subscribe(data => {
      if (data.success) {
        if (data.data != null) {
          var invoice = new StoreStatement();
          invoice.id = data.data;
          this.editInvoice(invoice);
        }
        this.notificationBuilder.showNotification('success', 1000, 'Criado com sucesso!')
        this.ngxSmartModalService.getModal('manualStatementModal').close()
      } else {
        this.notificationBuilder.showNotification('danger', 1000, 'ocorreu um erro')
      }
    })
  }

  openInvoice(invoice: any) {
    if (invoice.invoiceType == 5) {
      var win = window.open(Configuration.InvoiceUrl(invoice.id), '_blank');
      win.focus();
    }
    else {
      var win = window.open(invoice.invoiceUrl, '_blank');
      win.focus();
    }
  }

}

